import { render, staticRenderFns } from "./receipt-cards-to-pdf.vue?vue&type=template&id=66261d10"
import script from "./receipt-cards-to-pdf.vue?vue&type=script&lang=js"
export * from "./receipt-cards-to-pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports